const cleanStyles = (text) => {
  if (typeof text === 'string') {
    return text.replace(/ style="/g, ' _style="')
  }

  return text
}


export default cleanStyles
